import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Loading } from '../../components';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { Translate, LanguageConsumer } from '../../contexts/LanguageContext';
import './Login.css'
import { LanguageList, LanguageActive } from '../../components/LanguageList';
import { AuthConsumer } from '../../contexts/AuthContext';
import { Validator, ErrorMessage } from '../../components/Validator';
import { Popover, PopoverBody } from 'reactstrap';


export class Login extends Component {
    constructor(props) {
        super(props)
        this.Refs = React.createRef();

        this.state = {
            data: {
                AccountLogin: null,
                Password: null
            },
            dropdownOpenLanguage: false,
            showLoading: false,
            validation: {
                error: false,
                message: ""
            },
            popover_dismiss: false
        }
        this.handleChange = this.handleChange.bind(this);
        this.toggleLanguage = this.toggleLanguage.bind(this);
        this.loadingHandler = this.loadingHandler.bind(this);
        this.onLogin = this.onLogin.bind(this);
    }
    toggleLanguage() {
        this.setState(prevState => ({
            dropdownOpenLanguage: !prevState.dropdownOpenLanguage
        }));
    }
    handleChange(event) {
        let stateData = this.state.data;
        stateData[event.target.name] = event.target.value;
        this.setState({
            data: stateData
        });
    }
    loadingHandler(status, auth) {
        this.setState({ showLoading: status });

        if (!auth) {
            this.setState({
                validation: {
                    error: true,
                    message: Translate('Invalid Login Credentials')
                }
            });
        }
    }
    onLogin(e, loginHandler) {

        if (this.isValid()) {

            loginHandler(this.state.data, this.loadingHandler, e);
        }

    }
    isValid() {


        let error = Validator.Valid(this.state.data, this.Refs);

        this.setState({
            validation: error
        });

        return !error.error;
    }
    render() {
        return (
            <LanguageConsumer>
                {({ language, changeLanguage }) => (
                    <AuthConsumer>
                        {({ isAuth, checkAuth, loginHandler, returnPath, clearReturnPath }) => (
                            (this.state.showLoading) ? <Loading /> :
                                (isAuth && checkAuth) ?
                                    returnPath.path ?
                                        <>
                                            <Redirect to={returnPath.path} />

                                        </>
                                        :
                                        <Redirect to={"/Home"} />
                                    :
                                    (checkAuth) ?
                                        <React.Fragment>
                                            <div className="wrapper-page">
                                                <div className="card account-card mx-3">
                                                    <div className="bg-primary p-4 text-white text-center position-relative">
                                                        <h4 className="font-20 m-b-5">{Translate('Customer Panel')}</h4>
                                                        <p className="text-white-50 mb-4">{Translate('User account management panel.')}</p>
                                                        <Link to="/login" className="logo logo-admin"><img src="assets/images/logo/logo-icon.svg" height="48" alt="logo" /></Link>
                                                    </div>
                                                    <div className="account-card-content">
                                                        <ErrorMessage Validation={this.state.validation} />
                                                        <form className="form-horizontal m-t-30" ref={this.inputRefs} onKeyPress={(e) => { if (e.key === 'Enter') this.onLogin(e, loginHandler); }}>

                                                            <div className="form-group">
                                                                <label htmlFor="username">{Translate('User Id')}</label>
                                                                <input type="number" className="form-control" id="AccountLogin" name="AccountLogin" placeholder={Translate('Enter user id')} onChange={(e) => this.handleChange(e)} />
                                                            </div>

                                                            <div className="form-group">
                                                                <label htmlFor="userpassword">{Translate('Password')}</label>
                                                                <input type="password" className="form-control" id="userpassword" name="Password" autoComplete="new-password" placeholder={Translate('Enter password')} onChange={(e) => this.handleChange(e)} />
                                                            </div>
                                                            <div className="form-group">
                                                                <div className="input-group bootstrap-touchspin bootstrap-touchspin-injected tra-popover">
                                                                    <span className="input-group-append" id="Popoverdismiss">
                                                                        {Translate("Forgot Password?")}
                                                                    </span>
                                                                    <Popover placement="right" isOpen={this.state.popover_dismiss} target="Popoverdismiss" toggle={() => this.setState({ popover_dismiss: !this.state.popover_dismiss })}>
                                                                        <PopoverBody className="tra-popover__body">{Translate('Please send email to <a href="mailto:backoffice@artsmrkts.com" _target="blank">backoffice@artsmrkts.com</a> for your request.')}</PopoverBody>
                                                                    </Popover>
                                                                </div>
                                                            </div>


                                                            <div className="form-group row m-t-20">
                                                                <div className="col-sm-6">
                                                                    <li className="dropdown notification-list d-none d-md-block">
                                                                        <Dropdown isOpen={this.state.dropdownOpenLanguage} toggle={this.toggleLanguage}>
                                                                            <DropdownToggle className="nav-link nav-link-login dropdown-toggle arrow-none testflag waves-effect" caret tag="a">
                                                                                <LanguageActive lang={language} />
                                                                            </DropdownToggle>
                                                                            <DropdownMenu className="dropdown-menu dropdown-menu-right language-switch">
                                                                                <LanguageList lang={language} handleClick={(e, lang) => { changeLanguage(e, lang); this.toggleLanguage() }} />
                                                                            </DropdownMenu>
                                                                        </Dropdown>
                                                                    </li>
                                                                </div>
                                                                <div className="col-sm-6 text-right">
                                                                    <button type="button" className="btn btn-primary w-md waves-effect waves-light" onClick={(e) => { this.onLogin(e, loginHandler) }}>{Translate('Log In')}</button>
                                                                </div>

                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>

                                                <div className="m-t-40 text-center">
                                                    <p>{Translate('Don\'t have an account ?')} <a href="https://www.artsmrkts.com/campaigns/open-live-account" className="font-500 text-primary"> {Translate('Open Live Account')} </a> </p>
                                                    <p>© {new Date().getFullYear()} ARTSMRKTS </p>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                        : <Loading />
                        )}
                    </AuthConsumer>
                )}
            </LanguageConsumer>
        );
    }
}